export default "__VITE_ASSET__CGrjzfqA__"